"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RadioGroup = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _isNil2 = _interopRequireDefault(require("lodash/isNil"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Field = require("../Field");

var RadioGroup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(RadioGroup, _React$Component);

  function RadioGroup() {
    (0, _classCallCheck2["default"])(this, RadioGroup);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(RadioGroup).apply(this, arguments));
  }

  (0, _createClass2["default"])(RadioGroup, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      // Cannot use PureRenderMixin because we need deep comparison for props.options
      return !(0, _isEqual2["default"])(nextProps, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          options = _this$props.options,
          groupId = _this$props.id,
          groupValue = _this$props.value,
          onChange = _this$props.onChange,
          renderLabel = _this$props.renderLabel,
          inline = _this$props.inline,
          buttonGroup = _this$props.buttonGroup,
          toolbar = _this$props.toolbar,
          verticalButtonGroup = _this$props.verticalButtonGroup,
          responsive = _this$props.responsive;
      var optionObjects;

      if (Array.isArray(options)) {
        optionObjects = options;
      } else {
        optionObjects = Object.keys(options).map(function (key) {
          return {
            key: key,
            value: options[key]
          };
        });
      }

      var fieldClassName = (0, _classnames["default"])({
        'zsg-toolbar-form-field': toolbar
      });
      var items = optionObjects.map(function (option, index) {
        var key = option.key,
            value = option.value,
            disabled = option.disabled;
        var id = groupId + '-' + index;
        var checked = value === groupValue || // Exact equivalence or...
        // Neither value is null or undefined...
        !((0, _isNil2["default"])(value) || (0, _isNil2["default"])(groupValue)) && // ...and both are equivalent strings
        value.toString() === groupValue.toString();
        return _react["default"].createElement("li", {
          key: key,
          className: fieldClassName
        }, _react["default"].createElement("input", {
          id: id,
          name: groupId,
          value: value,
          onChange: onChange,
          checked: checked,
          disabled: disabled,
          type: "radio"
        }), _react["default"].createElement("label", {
          htmlFor: id
        }, renderLabel(key, option)));
      });
      var className = (0, _classnames["default"])({
        'zsg-form-group': !buttonGroup,
        'zsg-form-button-group': buttonGroup || verticalButtonGroup,
        'zsg-form-button-group_vertical': verticalButtonGroup,
        'zsg-form-button-group_static': !responsive,
        'zsg-list_inline': inline,
        'zsg-toolbar-form-group': toolbar
      });
      return _react["default"].createElement("ul", {
        className: className
      }, items);
    }
  }]);
  return RadioGroup;
}(_react["default"].Component);

exports.RadioGroup = RadioGroup;
RadioGroup.displayName = 'RadioGroupField';
RadioGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  id: _propTypes["default"].string.isRequired,

  /**
   * object - pairs of name -> value option elements.
   * or an array of { key, value, disabled } objects
   */
  options: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].shape({
    key: _propTypes["default"].any.isRequired,
    value: _propTypes["default"].any.isRequired,
    disabled: _propTypes["default"].bool
  })), _propTypes["default"].object]),
  value: _propTypes["default"].node,

  /**
   * Display the inputs and their labels in a horizontal row.
   */
  inline: _propTypes["default"].bool,

  /**
   * Hide the inputs and display their labels as buttons in a group.
   */
  buttonGroup: _propTypes["default"].bool,

  /**
   * Arrange the buttons in the group vertically with one button per row.
   */
  verticalButtonGroup: _propTypes["default"].bool,

  /**
   * Callback
   */
  onChange: _propTypes["default"].func,

  /**
   * Function override for label content with two parameters, the key and the
   * option object. Default function returns the key.
   */
  renderLabel: _propTypes["default"].func,

  /**
   * Passed when this component is composed (nested) inside of a <Toolbar>
   */
  toolbar: _propTypes["default"].bool,

  /**
   * Responsive by default (will switch to vertical layout on small screen sizes).
   * Set to false for static rendering.
   */
  responsive: _propTypes["default"].bool
} : {};
RadioGroup.defaultProps = {
  renderLabel: function renderLabel(key) {
    return key;
  },
  responsive: true
};
var RadioGroupField = (0, _Field.wrap)(RadioGroup);
var _default = RadioGroupField;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/RadioGroupField/index.js
// module id = 351
// module chunks = 0